import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Title = styled.h1`
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.neutral.black};
  font-weight: ${theme.typography.weight.xl};
  margin-top: 0;
`

export const Form = styled('form')`
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.xm};
  border-radius: ${theme.shapes.borderRadius.md};
  margin-bottom: 16px;
`

export const FieldsContainer = styled.div`
  display: grid;
  gap: ${theme.spacing.sm};
  margin-bottom: 16px;
`

type FieldWrapperProps = {
  templateColumns: string
  mediaTemplateColumns?: string
}

export const FieldWrapper = styled.div<FieldWrapperProps>`
  display: grid;
  grid-template-columns: ${(props) => props.templateColumns};
  gap: ${theme.spacing.sm} ${theme.spacing.md};
  width: 100%;

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: ${({ templateColumns, mediaTemplateColumns }) =>
      mediaTemplateColumns ? mediaTemplateColumns : templateColumns};
  }
`

export const FieldItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const LabelFilter = styled.div`
  display: flex;
  color: ${theme.colors.neutral.high};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes['2xs']};
  gap: ${theme.spacing.xs};
  align-items: center;
  white-space: nowrap;
  font-family: ${theme.typography.family.bold};
`

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`
